export default __webpack_public_path__ + "static/media/ic_pause.30175673.svg";